import type { HasFilter } from './types.flow';

const asHasFilterInput = (has: HasFilter): boolean => has;

export default asHasFilterInput;
